<ng-container *ngIf="resolvedUserName$ | async as userName">
  <app-avatar [name]="userName" [size]="size" [textSizeRatio]="textSizeRatio" *ngIf="!hideAvatar"></app-avatar>

  <div class="name-part">
    <truncated-text [text]="userName">
      <span suffix class="name-suffix-actions">
        <a [routerLink]="['/dashboard-individual', { user: userId }]" class="dashboard-link"
          (click)="$event.stopPropagation()" [matTooltip]="'common.viewUsersDashboard' | translate"
          *ngIf="!hideLink && ((role$ | async) !== 'guest')" matTooltipPosition="above"
          [trackClick]="{ selectedoption: { value: userName } }" trackType="no-link">
          <mat-icon>open_in_new</mat-icon>
        </a>
        <ng-content select="[suffix]"></ng-content>
      </span>
    </truncated-text>

    <ng-content></ng-content>
  </div>
</ng-container>
